import {
  ADDING_THEME_CONFIG_LOADING,
  ADDING_THEME_CONFIG_SUCCESS,
  ADDING_THEME_CONFIG_FAILED,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  data: null,
};

export const addingThemeConfigReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any; status: any }
) => {
  switch (action.type) {
    case ADDING_THEME_CONFIG_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case ADDING_THEME_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case ADDING_THEME_CONFIG_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
};
